<template>
    <div class="com-news-wp">
        <div class="title-more">
            <div class="t-m-blue"></div>
            <p class="t-m-t">{{newsTitle}}</p>
            <p class="t-m-m" @click="getList()">MORE +</p>
        </div>
        <div class="h-3-i-middle pointer" @click="getDetail(top.id)">
            <div class="h-3-i-img">
                <el-image v-if="top.fgpic" style="width: 100%; height: 100%" :src="top.fgpic" fit="contain">
                        <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                            <img style="object-fit: fill;width:100%;height:100%;"  src="../assets/image/home/home-img3.png">
                            </div> -->
                </el-image>
            </div>
            <p class="p1 p-lv-2 p-hover">{{top.infoTitle}}</p>
            <p class="p2 p-lv-2">{{top.abstract}}</p>
        </div>
        <div class="h-3-i-bottom">
            <div v-for="(item,index) in top6" :key="index" @click="getDetail(item.id)" class="item pointer">
                <div class="circle"></div>
                <p class="pull-left p-hover p1 p-lv">{{item.infoTitle}}</p>
                <p class="pull-right p2">{{item.createDate}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'comNews',
    data(){
        return{

        }
    },
    props:{
        newsTitle:{
            default:'',
        },
        top:{
            default(){
                return {};
            },
        },
        top6:{
            default(){
                return[];
            }
        }
    },
    methods:{
        getList(){
            this.$emit('getList',this.newsTitle);
        },
        getDetail(id){
            this.$emit('getDetail',id,this.newsTitle);
        }
    }
}
</script>
<style lang="scss" scoped>
.com-news-wp{
    width:100%;
    height:100%;
}
.h-3-i-middle{
            width:100%;
            height:140px;
            border-bottom:1px solid #F6F3F7;
            .h-3-i-img{
                width:150px;
                height:100px;
                padding: 25px 30px 0 20px;
                float: left;
                img{
                    width:100%;
                    height:100%;
                }
            }
            p{
                width:calc(100% - 220px);
                float: left;
            }
            .p1{
                margin-top:25px;
                font-size:16px;
                color:#444444;
                
            }
            .p1:hover{
                color:#0481F1;
            }
            .p2{
                margin-top:10px;
                font-size:13px;
                line-height:22px;
                color:#999999;
            }
        }
        .h-3-i-bottom{
            box-sizing: border-box;
            width:100%;
            padding: 10px 20px 0 20px;
            .item{
                width:100%;
                height:40px;
                .circle{
                    margin:17px 10px 0 0;
                    width:6px;
                    height:6px;
                    background:#656565;
                    border-radius:50%;
                    float: left;
                }
                p{
                    line-height:40px;
                }
                .p1{
                    font-size:15px;
                    width:75%;
                    color:#444444;
                }
                .p1:hover{
                    color:#0481F1;
                }
                .p2{
                    padding-right:10px;
                    color:#999999;
                }
            }
        }
</style>